import { useState } from 'react';
import { TableSort } from '@/types';
import { getNewSortStateTable } from '@/utils/tableSort';

/**
 * Sort state + toggling + data sorting for custom tables, using the same
 * comparator as GenericTable. Lets a bespoke table (e.g. one with expandable
 * rows) get sortable headers without being forced through GenericTable's row
 * model. Pair with the shared <SortArrow /> for the header indicator.
 */
export function useTableSort<T>(initial: TableSort<T>) {
  const [sort, setSort] = useState<TableSort<T>>(initial);

  const sortBy = (field: keyof T) =>
    setSort((prev) => getNewSortStateTable(field, prev));

  const sortData = (data: T[]): T[] =>
    [...data].sort((a, b) => {
      const aValue = a[sort.field];
      const bValue = b[sort.field];
      if (aValue > bValue) return sort.asc ? 1 : -1;
      if (aValue < bValue) return sort.asc ? -1 : 1;
      return 0;
    });

  return { sort, setSort, sortBy, sortData };
}
